import Card from '../components/Card';
import eventdata from "../data/events.json";
import { useState } from "react";
import Fade from 'react-reveal/Fade';
import { useLocation } from 'react-router-dom'

const Events = () => {

	const location = useLocation()
	const [isFilter, setIsFilter] = useState(location.state ? location.state : "all");
	const activeClass = "bg-white text-black cursor-default";

	return (
		<div>
			<img className="h-32 w-full object-cover md:h-40 lg:h-60" alt="events" src="https://images.unsplash.com/photo-1526478806334-5fd488fcaabc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1216&q=80" />

			<div className="mx-6 my-2 md:mx-16 md:mb-10">
				<h2 className="text-4xl font-bold text-center py-6 md:text-6xl md:py-12 lg:text-8xl">Events</h2>
			</div>

			<div className="flex flex-wrap justify-center mx-4 mb-8 gap-3 md:gap-6 md:mb-10 lg:gap-10">

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "all" ? activeClass : ""}`}
					onClick={() => { setIsFilter("all"); }}>All</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "individual" ? activeClass : ""}`}
					onClick={() => { setIsFilter("individual"); }}>Individual</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "team" ? activeClass : ""}`}
					onClick={() => { setIsFilter("team"); }}>Team</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "media" ? activeClass : ""}`}
					onClick={() => { setIsFilter("media"); }}>Media</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "dance" ? activeClass : ""}`}
					onClick={() => { setIsFilter("dance"); }}>Dance</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "music" ? activeClass : ""}`}
					onClick={() => { setIsFilter("music"); }}>Music</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "literary" ? activeClass : ""}`}
					onClick={() => { setIsFilter("literary"); }}>Literary</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "spoken" ? activeClass : ""}`}
					onClick={() => { setIsFilter("spoken"); }}>Spoken</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "theatre" ? activeClass : ""}`}
					onClick={() => { setIsFilter("theatre"); }}>Theatre</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "online" ? activeClass : ""}`}
					onClick={() => { setIsFilter("online"); }}>Online</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "open stage" ? activeClass : ""}`}
					onClick={() => { setIsFilter("open stage"); }}>Open Stage</button>

				<button className={`border px-4 py-1 rounded-full cursor-pointer ${isFilter === "deco" ? activeClass : ""}`}
					onClick={() => { setIsFilter("deco"); }}>Deco</button>
			</div>

			<div className="flex flex-wrap justify-center mb-24">
				{Object.keys(eventdata)
					.filter(row => eventdata[row].tags.includes(isFilter))
					.map((event) => {
						return <Fade bottom><Card id={event} title={eventdata[event].title} img_link={eventdata[event].img_link} /></Fade>
					})}
			</div>
		</div>
	);
}

export default Events;
